const Header = ({label}) => {
    return  <p className=' text-xl font-bold text-center m-4'>{label}</p>
}

export default Header